<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="9">
      <h1>Отзывы</h1>
    </v-col>
    <v-col cols="3" class="search-col">
      <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск"
              single-line
              otlined
              hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="12">
      <v-tabs v-model="tab">
        <v-tab>Негативные</v-tab>
        <v-tab>Позитивные</v-tab>
      </v-tabs>
      <v-slide-group class="text-right">
        <v-slide-item v-if="filters.created_at.valueFrom || filters.created_at.valueTo">
          <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="filters.created_at.valueFrom = null; filters.created_at.valueTo = null;"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
          >
            {{ filters.created_at.valueFrom }}{{filters.created_at.valueFrom && filters.created_at.valueTo ? ' - ' :
            ''}}{{ filters.created_at.valueTo }}
          </v-chip>
        </v-slide-item>
      </v-slide-group>
      <v-data-table
              class="mt-6"
              no-data-text="Нет отзывов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="reviews"
              v-model="selected"
              :search="search"
              :options.sync="options"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :server-items-length="total"
              :items-per-page="15"
              :loading="loading"
              :item-class="getClass"
              loading-text="Загрузка отзывов... Подождите пожалуйста"
      >
        <template v-slot:header.order.created_at>
          Заказ поступил<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.created_at.valueFrom || filters.created_at.valueTo}"
                 @click.stop.prevent="filters.created_at.modal = !filters.created_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.created_at>
          Отзыв поступил<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.created_at.valueFrom || filters.created_at.valueTo}"
                 @click.stop.prevent="filters.created_at.modal = !filters.created_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:item.order.created_at="{ item }">
          {{item.order ? item.order.created_at : '-'}}
        </template>
        <template v-slot:item.order.id="{ item }">
          {{item.order ? item.order.id : '-'}}
        </template>
        <template v-slot:item.user.name="{ item }">
          {{ item.user ? item.user.name : (item.order ? item.order.client_name : '-') }}
        </template>
        <template v-slot:item.user.phone="{ item }">
          {{ item.user ? item.user.phone : (item.order ? item.order.phone : '-') }}
        </template>
        <template v-slot:item.review.is_multiple="{ item }">
          <template v-if="item.is_multiple">
            Многороразовый
          </template>
          <template v-else>
            Одноразовый
          </template>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="currentReview = item; dialog = true; setProcessed(item)">
                  <v-list-item-title>Детали</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="dialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Отзыв о заказе
        </v-card-title>
        <v-card-text>
          <div class="tabs-slide">
            <div class="tab open">
              <div class="head"><span>Еда</span> <stars v-model="currentReview.food" :clickable="false"></stars></div>
              <div class="input">
                <v-textarea outlined no-resize readonly hide-details label="Детали" v-model="currentReview.food_text" rows="2"></v-textarea>
              </div>
            </div>
            <div class="tab open">
              <div class="head"><span>Сервис</span> <stars v-model="currentReview.pack" :clickable="false"></stars></div>
              <div class="input">
                <v-textarea outlined no-resize readonly hide-details label="Детали" v-model="currentReview.pack_text" rows="2"></v-textarea>
              </div>
            </div>
            <div class="tab open">
              <div class="head"><span>Доставка</span> <stars v-model="currentReview.delivery" :clickable="false"></stars></div>
              <div class="input">
                <v-textarea outlined no-resize readonly hide-details label="Детали" v-model="currentReview.delivery_text" rows="2"></v-textarea>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
                  outlined
                  @click="dialog = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="filters.created_at.modal"
            max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                      ref="createdAtValueFromModal"
                      v-model="filters.created_at.valueFromModal"
                      :return-value.sync="filters.created_at.tempValueFrom"
                      width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                          v-model="filters.created_at.tempValueFrom"
                          label="От"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                        v-model="filters.created_at.tempValueFrom"
                        scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                          text
                          color="primary"
                          @click="filters.created_at.valueFromModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                          text
                          color="primary"
                          @click="$refs.createdAtValueFromModal.save(filters.created_at.tempValueFrom  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                      ref="createdAtValueToModal"
                      v-model="filters.created_at.valueToModal"
                      :return-value.sync="filters.created_at.tempValueTo"
                      width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                          v-model="filters.created_at.tempValueTo"
                          label="От"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                        v-model="filters.created_at.tempValueTo"
                        scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                          text
                          color="primary"
                          @click="filters.created_at.valueToModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                          text
                          color="primary"
                          @click="$refs.createdAtValueToModal.save(filters.created_at.tempValueTo  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setCreatedAtFilter">Выбрать</v-btn>

          <v-btn
                  outlined
                  @click="filters.created_at.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import ReviewService from '../../api/ReviewService'
    import Stars from '../../components/Stars'

    export default {
        name: 'ProductIndex',
        components: {Stars},
        data: () => ({
            loading: false,
            search: '',
            selected: [],
            reviews: [],
            dialog: false,
            currentReview: {},
            options: {},
            filters: {
                created_at: {
                    valueFrom: '',
                    valueFromModal: false,
                    valueTo: '',
                    valueToModal: false,
                    tempValueFrom: '',
                    tempValueTo: '',
                    modal: false,
                },
            },
            footerProps: {
                itemsPerPageText: 'Отзывов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
              itemsPerPageOptions: [15, 30]
            },
            tab: 0,
            total: 0,
            headers: [
                {
                    text: 'Дата / время',
                    value: 'created_at'
                },
                {
                    text: 'Дата / время',
                    value: 'order.created_at'
                },
                {
                    text: 'ID заказа',
                    sortable: false,
                    value: 'order.id',
                },
                {
                    text: 'Клиент',
                    value: 'user.name',
                },
                {
                  text: 'Телефон',
                  sortable: false,
                  value: 'user.phone',
                },
                {
                  text: 'Еда',
                  sortable: false,
                  value: 'food',
                },
                {
                  text: 'Доставка',
                  sortable: false,
                  value: 'delivery',
                },
                {
                  text: 'Сервис',
                  sortable: false,
                  value: 'pack',
                },
                {
                  text: 'Оценка',
                  sortable: false,
                  value: 'rate',
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"}
            ],
        }),
        mounted() {
        },
        watch: {
            "filters.created_at.valueFrom": {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            "filters.created_at.valueTo": {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            search() {
              clearTimeout(this.timerId)
              this.timerId = setTimeout(() => {
                this.getDataFromApi()
              }, 700)
            },
            tab() {
                this.getDataFromApi()
            },
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
            setCreatedAtFilter(e) {
                this.filters.created_at.valueTo = this.filters.created_at.tempValueTo
                this.filters.created_at.valueFrom = this.filters.created_at.tempValueFrom
                this.filters.created_at.modal = false;
            },
            setProcessed(item){
                ReviewService.setProcessed(item.id)
            },
            getClass(item){
                if(item.processed){
                    return ''
                } else {
                    return 'changed-row'
                }
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                let params = {
                  page: this.options.page,
                  perPage: this.options.itemsPerPage,
                    createdAtFrom: this.filters.created_at.valueFrom,
                    createdAtTo: this.filters.created_at.valueTo,
                  sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
                  sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
                  search: this.search,
                  type: this.tab === 0 ? 'negative' : 'positive'
                }

                ReviewService.list(params)
                    .then(response => {
                        this.reviews = response.data.data
                        this.total = response.data.total
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .light-red{
    background-color: #FFEEEC;
  }
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .description{
    color: #8C959D;
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 34px;
  }

  .buttons{
    margin-top: 38px;
    span{
      margin-right: 14px;
    }
  }

  .tabs-slide{
    .tab{
      padding: 14px 22px;
      border-top: 1px solid #E0E8F0;
      border-right: 1px solid #E0E8F0;
      border-left: 1px solid #E0E8F0;
      box-sizing: border-box;
      height: 55px;
      overflow: hidden;
      -webkit-transition: all .2s ease;
      -moz-transition: all .2s ease;
      -ms-transition: all .2s ease;
      -o-transition: all .2s ease;
      transition: all .2s ease;
      .input{
        margin-bottom: 0;
        textarea{
          padding: 10px 14px!important;
          font-size: 14px;
          line-height: 16px;
          background-color: #F8FBFF;
          font-weight: 400;
          &::placeholder{
            color: #212529;
          }
        }
      }
      &:last-child{
        border-bottom: 1px solid #E0E8F0;
      }
      .head{
        font-size: 22px;
        line-height: 26px;
        color: #212529;
        margin-bottom: 14px;
        display: flex;
        justify-content: space-between;
        span{
          text-transform: capitalize;
        }
      }
      &.open{
        height: auto;
      }
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
